export default "__VITE_ASSET__CPMHtqgY__"